module.exports = __webpack_public_path__ + "img/collective-view-more-active.03e2cec4.png";